var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread"},[_c('h3',[_c('span',{staticClass:"bread-title"},[_vm._v(_vm._s(_vm.title)+" ")]),_vm._v(_vm._s(_vm.title)+"\n    ")]),_c('Breadcrumb',{staticClass:"bread-subtitle"},[_c('BreadcrumbItem',{attrs:{"to":"/panel"}},[_vm._v(_vm._s(_vm.home||'主面板'))]),_c('BreadcrumbItem',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }